module.exports = __webpack_public_path__ + "static/media/8.aacddfb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/8.png
// module id = 1216
// module chunks = 0